'use client';

import type { ICellRendererParams } from 'ag-grid-community';
import type { TracePreviewDto } from '@terra/shared-contracts-trace';
import { SignalStatus } from '@terra/shared-schemas-orchestrator';
import { SignalStatusBadge } from '../signals/SignalStatusBadge';
import { WithInfinitetableLoadingCellSkeleton } from '../table/WithInfinitetableLoadingCellSkeleton';
import { resolveTraceResultDisplay } from './traces-table-result-display';

export function TraceResultBadge({ trace }: { trace: TracePreviewDto }) {
  const display = resolveTraceResultDisplay(trace);

  if (display.kind === 'empty') {
    return null;
  }

  if (display.kind === 'signal') {
    return (
      <SignalStatusBadge
        status={display.status}
        stage={display.stage}
        blockedReason={display.blockedReason}
        confirmedVulnerabilityFindingState={
          display.confirmedVulnerabilityFindingState
        }
        tooltipTitle={display.skipAttackReason}
      />
    );
  }

  return (
    <SignalStatusBadge
      status={SignalStatus.BLOCKED}
      blockedReason="guardrails"
      tooltipTitle={display.skipAttackReason}
    />
  );
}

export function TracesTableResultCell({
  params,
}: {
  params: ICellRendererParams<TracePreviewDto>;
}) {
  if (!params.data) {
    return <WithInfinitetableLoadingCellSkeleton params={params} />;
  }

  return <TraceResultBadge trace={params.data} />;
}
